export default {
  CountdownTimer: {
    mounted() {
      this.countdownInterval = null;
      this.isDestroyed = false;
      this.startCountdown();
    },

    updated() {
      this.startCountdown();
    },

    destroyed() {
      this.isDestroyed = true;
      this.stopCountdown();
    },

    stopCountdown() {
      if (!this.countdownInterval) return;

      clearInterval(this.countdownInterval);
      this.countdownInterval = null;
    },

    startCountdown() {
      this.stopCountdown();

      if (this.isDestroyed) return;

      const el = this.el;
      const waitUntil = el.dataset.waitUntil;
      if (!waitUntil) return;

      const targetTime = new Date(waitUntil).getTime();

      // Update immediately
      this.updateDisplay(el, targetTime);

      // Update every second
      this.countdownInterval = setInterval(() => {
        this.updateDisplay(el, targetTime);
      }, 1000);
    },

    updateDisplay(el, targetTime) {
      if (this.isDestroyed || !el.isConnected) {
        this.stopCountdown();
        return;
      }

      const now = new Date().getTime();
      const timeLeft = targetTime - now;

      const label = el.querySelector('[data-countdown-label]') || el;
      const spinner = el.querySelector('[data-countdown-spinner]');

      if (timeLeft <= 0) {
        if (spinner) {
          label.classList.add('hidden');
          spinner.classList.remove('hidden');
        } else {
          label.textContent = '00:00';
        }

        this.stopCountdown();
        return;
      }

      if (spinner) {
        spinner.classList.add('hidden');
        label.classList.remove('hidden');
      }

      const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
      const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

      let formattedTime;
      if (days > 0) {
        formattedTime = `${days}d ${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
      } else if (hours > 0) {
        formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
      } else {
        formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
      }
      label.textContent = formattedTime;
    },
  },
};
